import NET from './net';

const API_URL = 'https://monitor.protezionecivile.fvg.it/api';

class MonitorApi {

  prepareTime(hours) {
    const max_time = 3600000 * hours;
    const time = new Date(new Date() - max_time).toISOString();
    return time;
  }

  async getStations() {
    const url = API_URL + '/stations';
    return NET.get( url ).then( (result) => result.stations );
  }

  async getWebcams() {
    const url = API_URL + '/webcams';
    return NET.get( url ).then( (result) => result.webcams );
  }

  async getWebcamImages(webcam_id, num_images) {
    const url = API_URL + '/webcams/' + webcam_id + '/images?last=' + num_images;
    return NET.get( url ).then( (result) => result.images );

  }

  async getStation(station_id) {
    const url = API_URL + '/stations/' + station_id;
    return NET.get( url ).then( (result) => result.station );
  }

  async searchStations( key, value ) {
    if(['istat', 'name', 'position'].includes(key)){
      const url = API_URL + '/stations/search?' + key +'=' + value;
      return NET.get( url ).then( (result) => result.stations );  
    }
    else {
      return Promise.resolve([]);
    }
  }

  async getStationSensors( station_id ) {
    const url = API_URL + '/stations/' + station_id + '/sensors';
    return NET.get( url ).then( (result) => result.sensors );
  }

  async getSensorMeasures( station_id, sensor_id, from, to) {
    let url = API_URL + '/stations/' + station_id + '/sensors/' + sensor_id + '/measures?from=' + from;
    if(to != undefined)
      url = url + '&to=' + to;
    return NET.get( url ).then( (result) => result.measures );
  }

  async getMeasuresForStation( station, sensors_of_interest, sensors_to_exclude, hours ) {
    const from = this.prepareTime(hours);
    let sensors = await this.getStationSensors( station.id );
    if(station.sensors == undefined)
      station.sensors = []
    for (let j = 0; j < sensors.length; j++) {
      const sensor = sensors[j];
      if((sensors_of_interest.length == 0 || sensors_of_interest.indexOf(sensor.code) >= 0) && sensors_to_exclude.indexOf(sensor.code) == -1) {
        sensor.measures = await this.getSensorMeasures( station.id, sensor.id, from );
        station.sensors.push(sensor);
      }
    }
    return station;
  }

  async getMeasuresForStations( stations, sensors_of_interest, sensors_to_exclude, hours ) {
    for (let i = 0; i < stations.length; i++) {
      await this.getMeasuresForStation( stations[i], sensors_of_interest, sensors_to_exclude, hours )
    }
    return stations;
  }

  async getCloudCover(position, from) {
    const url = API_URL + '/cloud_covers/' + position + '?from=' + from;
    return NET.get( url ).then( (result) => result.cloud_covers );  
  }

  async getEphemerides(from) {
    const url = API_URL + '/ephemerides?from=' + from;
    return NET.get( url ).then( (result) => result.ephemerides );  
  }

  async getLatestMeasures(sensor_id) {
    const url = API_URL + '/sensors/' + sensor_id + '/measures/latest';
    return NET.get( url ).then( (result) => result.measures );
  }

  async getLatestImages() {
    const url = API_URL + '/images/latest';
    return NET.get( url ).then( (result) => result.images );
  }

  async getRadarProducts(radar_id, product, from, to, num_layers) {
    let format = "image/png"
    if(product == 'HRT'){
      format = 'application/json'
    }
    const url = API_URL + '/radars/' + radar_id + '/products?last=' + num_layers + '&name=' + product + '&format=' + format + '&order=DESC&from=' + from.toISOString() + '&to=' + to.toISOString();
    return NET.get( url ).then( (result) => result.products );
  }

  async getRadarProduct(product_id) {
    const url = API_URL + '/products/' + product_id;
    return NET.get( url ).then( (result) => result );
  }

  async getEarthquakes(what) {
    let url = API_URL + '/earthquakes';
    if(what == 'l50'){
      url += "?from=2000-01-01&last=50&order=DESC"
    }
    else if(what == 'd5'){
      const from = this.prepareTime(5*24);
      url += "?from=" + from;
    }
    else if(what == 'd10'){
      const from = this.prepareTime(10*24);
      url += "?from=" + from;
    }
    else if(what == 'd20'){
      const from = this.prepareTime(20*24);
      url += "?from=" + from;
    }
    else if(what == 'm3'){
      url += "?from==2000-01-01&magnitudo=3";
    }
    return NET.get( url ).then( (result) => result.earthquakes );
  }

  async getMeteogramData( position, sensor_codes ) {
    const from = this.prepareTime(36);
    const sensors_of_interest = sensor_codes || ['P', 'B', 'T', 'Vv', 'Dv'];

    let measures = {};
    let used_sensors = {};
    let used_stations = {};

    let stations = await this.searchStations( 'position', position );

    let ephemerides = await this.getEphemerides(from);

    for (let i = 0; i < stations.length; i++) {
      const station = stations[i];

      let sensors = await this.getStationSensors( station.id );

      for (let j = 0; j < sensors.length; j++) {
        const sensor = sensors[j];

        if(sensors_of_interest.indexOf(sensor.code) >= 0 && used_sensors[sensor.code] == null ) {
          used_sensors[sensor.code] = sensor;
          used_stations[station.id] = station;

          let sensor_measures = await this.getSensorMeasures( station.id, sensor.id, from );

          for (let k = 0; k < sensor_measures.length; k++) {
            const m = sensor_measures[k];
            let x = measures[m.dt];
            if( !x ) {
              x = {};
              measures[m.dt] = x;
            }
            x[sensor.code] = m.value;
          }
        }
      }
    }
    let cloud_cover = await this.getCloudCover( position, from );
    for (let k = 0; k < cloud_cover.length; k++) {
      const m = cloud_cover[k];
      let x = measures[m.dt];
      if( !x ) {
        x = {};
        measures[m.dt] = x;
      }
      x['CC'] = m.value;
    }

    let res = Object.keys( measures ).map( k => {
      let m = measures[k];
      return {
        dt: k,
        ... m
      };
    });
    return { stations: used_stations, ephemerides: ephemerides[0], measures: res.sort( (a,b) => (a.dt < b.dt ? -1 : a.dt > b.dt ? 1 : 0) ) };
  }
}

let Service = new MonitorApi();

export default Service;
